import React from "react";
import { useNavigate } from "react-router-dom";

import FleetApplicationCard from "@/components/business/cards/FleetApplicationCard";

const FleetApplicationPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = async (formData: any) => {
    try {
      console.log("Fleet application submitted:", formData);
      // Here you would normally send the data to your API
      // const response = await businessService.submitFleetApplication(formData);

      // For now, just simulate success and redirect
      setTimeout(() => {
        alert(
          "Fleet application submitted successfully! We'll review your application and get back to you within 2-3 business days.",
        );
        navigate("/");
      }, 1000);
    } catch (error) {
      console.error("Error submitting fleet application:", error);
      alert("Error submitting application. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 dark:bg-gray-900">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Partner with Hareeng Fleet
          </h1>
          <p className="mt-2 text-lg text-gray-600 dark:text-gray-400">
            Grow your fleet business with our platform
          </p>
        </div>

        <FleetApplicationCard onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default FleetApplicationPage;
